import { render, staticRenderFns } from "./CommonHeader.vue?vue&type=template&id=70d65d4c&scoped=true&lang=html&"
import script from "./CommonHeader.vue?vue&type=script&lang=js&"
export * from "./CommonHeader.vue?vue&type=script&lang=js&"
import style0 from "./CommonHeader.vue?vue&type=style&index=0&id=70d65d4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d65d4c",
  null
  
)

export default component.exports